import { Utils } from "utils";
import { RootState } from "store/store";

export const selectRouteRequest = (state: RootState) => state.routeRequest.data;

export const selectIsGenerateRouteEnabled = (state: RootState) => {
  const request = state.routeRequest.data;
  const isFullfilled = Utils.Route.isRequestFullfilled(request);

  return isFullfilled.points && isFullfilled.duration && isFullfilled.tags;
};
